<template>
  <div>
    <!-- Placeholder for reject modal - can be implemented using existing modal system -->
  </div>
</template>

<script>
export default {
  name: 'RejectModal',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
}
</script>
